module.exports = __webpack_public_path__ + "img/骷髅.4470a3cf.png";